import React, { useEffect } from 'react';
import GeneralButton from './GeneralButton';
import './Start.css';

const ScenarioStart = (obj: any) => {
	
	const onChangeValueKeyboard = (e:any)=> {
		if(e.keyCode == 32 || e.keyCode == 13){ //32 - spacebar, 36 - enter
			obj.parameters.onClose();
		}
	};

	useEffect(() => {
		let title = document.getElementById('scenario-start-title');
		if (title){
			title.focus();
		}
	}, [obj.parameters])

	return (
		<div className="ui-container start-container modal-disable-select">
			<div className="modal-background">
				<div className="modal-background-shadow"></div></div>
			<div className="ui-inner-container" style={{
				width: '100%',
				height: '100%'
			}}>
				<div
					style={{
						width: '773px',
						margin: '0 auto',
						position: 'relative',
						top: '50%',
						userSelect: 'none',
						transform: 'translate(0, -50%)'
					}}>
					<img src="./assets/startscreen/bg.png" style={{
						pointerEvents: 'none',
						userSelect: 'none',
					}} />
					<div
						onClick={obj.parameters.onClose}
						onKeyDown={onChangeValueKeyboard}>
						<img 
							tabIndex={0}
							src="./assets/startscreen/close.png" 
							alt="close" 
							style={{
								position: 'absolute',
								left: '25px',
								top: '25px',
								width: '43px',
								userSelect: 'none',
								cursor: 'pointer'
							}} 
						/>
					</div>
					<p id="scenario-start-title" style={{
						fontSize: '30px',
						fontWeight: 'bold',
						margin: '0',
						position: 'absolute',
						top: '26px',
						width: '94%',
						right: '0',
						pointerEvents: 'none',
						color: 'white'
					}}
					tabIndex={0}>{obj.parameters.title}</p>
					<p style={{
						fontSize: '20px',
						margin: '0px',
						position: 'absolute',
						top: '80px',
						width: '100%',
						paddingLeft: '27px',
						paddingRight: '27px',
						right: '0px',
						pointerEvents: 'none',
						textAlign: 'left',
						color: 'white'
					}} 
					dangerouslySetInnerHTML={{__html: obj.parameters.text}}
					tabIndex={0}>
					</p>
					<GeneralButton key="Start Scenario" text="Start Scenario" onClick={obj.parameters.onDone} style={{
						position: 'absolute',
						bottom: '50px',
						width: '220px',
						/* margin: 0 auto; */
						left: '50%',
						transform: 'translate(-50%, 0)'
					}} />
				</div>
				{/* <p>Click Start to begin</p>
				<button onClick={obj.parameters.onDone}>Start</button> */}
			</div>

		</div>
	);
};

export default ScenarioStart;
